module.exports = __webpack_public_path__ + "img/suHalf.ca0e8604.png";